import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';
import { Link } from 'react-router';
import { Button } from 'react-bootstrap';
import { push, replace } from 'react-router-redux'
import {connect} from 'react-redux';
import axios from "axios"
import conf from '../../_Conf'

class Reg_done_cust extends Component {
  componentWillMount = () =>{
    try {
      let st = this.props.location.state.form
      delete st['Time']
    } catch {
        this.props.replace("/air-res2025/registration_start")
    }
    let obj = {
        ...this.props.location.state.result.paymentIntent,
        ...this.props.location.state.form,
        prev_payments: ''
    }
    axios.post(conf.Production? conf.ProductionAddress + 'air-res2025/logger/' : 'http://127.0.0.1:5050/' + 'air-res2025/logger/',
        obj,
        { headers: { 'Content-Type': 'application/json' } }
        ).then(response => {
            // console.log(response.data)
        }
      )
    // console.log(obj)
  }
  
  
  render() {
    return (
      <div className="r_container">
        <div className="home">


          <div className="new_banner">
            <div className="banner_content">
              <h1>air-res 2025</h1>
              <h6>The 2024 World Congress in</h6>
              <h6>Computer Science, Computer Engineering, & Applied Computing (csci)</h6>
              <h6>July 26-29, 2024, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
          <h4 className="par_header">Registration - Success!</h4>
            <div className="par">            
                <div style={{
                    margin: "2rem auto",
                    fontSize: "30px",
                    color: "green"
                }}>SUCCESS!</div>
                This is an automated message to confirm that your payment has been submitted. <br/>
                You should receive a confirmation email soon.
                
                <br/><br/>

                <div>
                    <div> <b>Payment ID: </b> {this.props.location.state.result.paymentIntent.id}</div>
                    <div> <b>Amount: </b> ${this.props.location.state.result.paymentIntent.amount / 100}.00</div>
                    <div> <b>Receipt Email: </b>{this.props.location.state.result.paymentIntent.receipt_email}</div>
                    <div> <b>Name: </b> {this.props.location.state.form.fn} {this.props.location.state.form.ln}</div>
                </div>

                <br/>
                <br/>

                <b>Please save/print this page for your records.</b>

                <br/>
                <br/>

            </div>
            

          </div>
          

        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
    return {
    }
  }
  
  const mapDispatchToProps = () => {
    return {
      push,
      replace
    }
  }
  export default connect(mapStateToProps, mapDispatchToProps())(Reg_done_cust);